import styled from "styled-components";
const Icons = styled.div`
  & svg {
    height: 30px;
    width: 30px;
    color: #64ffda;
    margin: 5px;
  }
  & svg:hover {
    height: 40px;
    width: 40px;
  }
`;
export default Icons;
